<template>
  <div>
    <div class="d-flex">
      <report-description
        :description="collection.description[0]"
        :maxLength="500"
      ></report-description>
      <collection-selector
        class="mb-2 ml-auto"
        v-if="isTopLevelCollection"
        :biobankData="in_series"
        :collectionData="collection"
      />
    </div>

    <!-- collection information -->
    <view-generator v-if="collectionModel.viewmodel" :viewmodel="collectionModel.viewmodel" />
  </div>
</template>

<script>
import { getCollectionDetails } from "../../functions/viewmodelMapper";
import CollectionSelector from "../checkout-components/CollectionSelector.vue";
import ReportDescription from "../report-components/ReportDescription.vue";
import ViewGenerator from "../generators/ViewGenerator.vue";

export default {
  name: "ReportCollectionDetails",
  props: {
    in_series: {
      type: Object,
      required: true,
    },
    collection: {
      type: Object,
      required: true,
    },
  },
  components: {
    CollectionSelector,
    ReportDescription,
    ViewGenerator,
  },
  computed: {
    collectionModel() {
      return this.collection ? getCollectionDetails(this.collection) : {};
    },
    isTopLevelCollection() {
      return this.collection.parent_collection === undefined;
    },
  },
};
</script>
